import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import { Grid, Typography, Card, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddVender() {
  const classes = useStyles();
  const [venderType, setVenderType] = useState("");
  const [name, setName] = useState();
  const [code, setCode] = useState();
  const [status, setStatus] = useState(1);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  // console.log(EmpId);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ผู้ขาย
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Vender
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Vender
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ name: ""}}
          validate={(values) => {
           
          }}
          onSubmit={(values, { setSubmitting }) => {
            console.log(values);
            setTimeout(() => {
              const data = {
                VenderType: venderType,
                VenderNo: code,
                VenderName: name,
                VenderMAC5Code: mac5code,
                VenderAddress: address,
                VenderContactName: contact,
                VenderEmail: email,
                VenderTel: tel,
                status: 1,
                // createId: EmpId,
              };

              api
                .post("api/vender/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มข้อมูลผู้ขาย !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/vender");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px", marginBottom:"10px" }} className="textcolordarkblue">
                เพิ่มข้อมูลผู้ขาย
              </h6>
              <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth required>
                    <InputLabel id="select_vender_type-label" shrink>
                      Vender Type
                    </InputLabel>
                    <Select
                      labelId="select_vender_type-label"
                      id="select_vender_type"
                      value={venderType}
                      label="Vender Type"
                      displayEmpty
                      notched
                      onChange={(e) => setVenderType(e.target.value)}
                    >
                      <MenuItem value="" disabled>
                        <em>Select Vender Type</em>
                      </MenuItem>
                      <MenuItem value="Shipping Agent">Shipping Agent</MenuItem>
                      <MenuItem value="Trucking Agent">Trucking Agent</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={9}></Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Vender"
                    variant="outlined"
                    placeholder="Vender"
                    style={{ width: "100%" }}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={name}
                    classes={{ root: !name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.f_t_name && touched.f_t_name && errors.f_t_name} */}
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>
               

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Vender Code"
                    variant="outlined"
                    placeholder="Enter Vender Code"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setCode(e.target.value)
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={code}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="Enter MAC-5 Code "
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setMAC5Code(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={mac5code}

                  />
                </Grid>
                
                <Grid item xs={12} sm={6} md={6}></Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Address"
                    variant="outlined"
                    placeholder="Enter Address"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setAddress(e.target.value)
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={address}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Contact Name"
                    variant="outlined"
                    placeholder="Enter Contact Name"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setContact(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={contact}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    placeholder="Enter Email"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={email}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Telephone"
                    variant="outlined"
                    placeholder="Enter Telephone"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setTel(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={tel}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  {/* <TextField
                    label="FREIGHT TERMS NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter FREIGHT TERMS NO."
                    name="f_t_no"
                    style={{
                      width: "40%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => setF_t_no(e.target.value)}
                    onBlur={handleBlur}
                    value={f_t_no}
                  />
                  {errors.f_t_no && touched.f_t_no && errors.f_t_no} */}

                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      id="select_status"
                      value={status}
                      style={{
                        width: "100%",
                        // marginLeft: "10px",
                        // marginTop: "10px",
                        // marginBottom: "10px",
                      }}
                      label="Status"
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
